import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialog-footer" }

import { ref } from "vue";

enum StatusOption {
  Dealing = "Dealing",
  Finance = "Finance",
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangeStatusModal',
  emits: ["submit"],
  setup(__props, { expose: __expose, emit: emits }) {

const dialogRef = ref(false);
const isSubmitting = ref(false);
const selected = ref<StatusOption>(StatusOption.Dealing);
const currentItem = ref<any>(null);



const show = (item: any) => {
  currentItem.value = item;
  selected.value = StatusOption.Dealing;
  dialogRef.value = true;
};

const close = () => {
  dialogRef.value = false;
  isSubmitting.value = false;
};

const onSave = () => {
  // TODO: wire to API once endpoint is provided
  emits("submit", { item: currentItem.value, status: selected.value });
  close();
};

__expose({ show });

return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogRef.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogRef).value = $event)),
    title: _ctx.$t('action.changeStatus'),
    width: "480px",
    "align-center": "",
    "before-close": close
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_button, {
          onClick: close,
          disabled: isSubmitting.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          color: "#ffce00",
          loading: isSubmitting.value,
          onClick: onSave
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.save")), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_radio_group, {
        modelValue: selected.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selected).value = $event)),
        class: "d-flex flex-column gap-3 p-2"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_radio, {
            value: StatusOption.Dealing,
            size: "large"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Dealing 審核 ")
            ]),
            _: 1
          }, 8, ["value"]),
          _createVNode(_component_el_radio, {
            value: StatusOption.Finance,
            size: "large"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 財務部門 審核 ")
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})